export default {
  all: [],
  guests: [],
  one: {},
};
